import { render, staticRenderFns } from "./ChangePassword.vue?vue&type=template&id=36cffcf6&"
import script from "./ChangePassword.vue?vue&type=script&lang=js&"
export * from "./ChangePassword.vue?vue&type=script&lang=js&"


/* normalize component */
import normalizer from "!../../../../node_modules/vue-loader/lib/runtime/componentNormalizer.js"
var component = normalizer(
  script,
  render,
  staticRenderFns,
  false,
  null,
  null,
  null
  
)

/* hot reload */
if (module.hot) {
  var api = require("/opt/build/repo/node_modules/vue-hot-reload-api/dist/index.js")
  api.install(require('vue'))
  if (api.compatible) {
    module.hot.accept()
    if (!api.isRecorded('36cffcf6')) {
      api.createRecord('36cffcf6', component.options)
    } else {
      api.reload('36cffcf6', component.options)
    }
    module.hot.accept("./ChangePassword.vue?vue&type=template&id=36cffcf6&", function () {
      api.rerender('36cffcf6', {
        render: render,
        staticRenderFns: staticRenderFns
      })
    })
  }
}
component.options.__file = "src/views/User/ChangePassword/ChangePassword.vue"
export default component.exports